
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class Lvl extends Vue {
    @Prop({ required: true }) level! : string | number
}
